<template>
  <button
    :disabled="disabled"
    aria-hidden="true"
    type="button"
    @click="onClick">
    <em
      :id="id"
      :title="title"
      :class="visible ? 'icon-eye-open' : 'icon-eye-close'"
      class="qx-icon visibility-icon"
      aria-hidden="true" />
  </button>
</template>

<script>
export default {
  name: 'VisibilityButton',
  props: {
    id: {
      type: String,
      default: '',
    },
    visible: {
      type: Boolean,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    visibleTitle: {
      type: String,
      default: '',
    },
    hiddenTitle: {
      type: String,
      default: '',
    },
  },
  emits: ['toggle-visibility'],
  computed: {
    title() {
      if (this.visible) {
        return this.hiddenTitle || this.$gettext('Hide password');
      } else {
        return this.visibleTitle || this.$gettext('Show password');
      }
    },
  },
  methods: {
    onClick() {
      this.$emit('toggle-visibility');
    },
  },
};
</script>

<style lang="scss" scoped>
.visibility-icon {
  padding: 0;
  height: 35px !important;
  background: transparent;
  border: 1px solid $gray-400;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  cursor: pointer;
  color: $icon-grey;
  font-size: 32px;
  &:hover,
  &:focus {
    text-decoration: none;
    color: $base-orange;
  }
}
</style>
